import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'bushDark',
      d: 'M-0.5,-3.5h1v0.5h-1zM-2,-3h1v0.5h-1zM1,-3h1v0.5h-1zM-2.5,-2.5h1v0.5h-1zM1.5,-2.5h1v0.5h-1zM2,-2h0.5v0.5h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM1.5,-1.5h1v0.5h-1zM-2.5,-1h1v0.5h-1zM-1,-1h3.5v0.5h-3.5zM-2.5,-0.5h5v0.5h-5zM-1.5,0h3.5v0.5h-3.5z',
    },
    {
      paint: 'bush',
      d: 'M-1,-3h2v0.5h-2zM1,-2.5h0.5v0.5h-0.5zM-2.5,-2h1v0.5h-1zM-0.5,-2h2.5v0.5h-2.5zM-2,-1.5h3.5v0.5h-3.5zM-1.5,-1h0.5v0.5h-0.5z',
    },
    { paint: 'leafLight', d: 'M-1.5,-2.5h2.5v0.5h-2.5zM-1.5,-2h1v0.5h-1z' },
  ],
  pixels: 67,
};
const variant1: PixelSprite = {
  layers: [
    {
      paint: 'bushDark',
      d: 'M-2.5,-2.5h1.5v0.5h-1.5zM-0.5,-2.5h1v0.5h-1zM1,-2.5h1v0.5h-1zM-3,-2h1v0.5h-1zM0.5,-2h2v0.5h-2zM-3.5,-1.5h0.5v0.5h-0.5zM2.5,-1.5h1v0.5h-1zM-4,-1h1v0.5h-1zM2,-1h2v0.5h-2zM-3.5,-0.5h7.5v0.5h-7.5zM-3,0h5.5v0.5h-5.5z',
    },
    {
      paint: 'bush',
      d: 'M-2,-2h2.5v0.5h-2.5zM-3,-1.5h0.5v0.5h-0.5zM-0.5,-1.5h3v0.5h-3zM-3,-1h5v0.5h-5z',
    },
    { paint: 'leafLight', d: 'M-2.5,-1.5h2v0.5h-2z' },
  ],
  pixels: 74,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'bushDark',
      d: 'M-0.5,-3.5h1v0.5h-1zM-1.5,-3h0.5v0.5h-0.5zM1.5,-2.5h1v0.5h-1zM2,-2h0.5v0.5h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM1.5,-1.5h1v1h-1zM-2.5,-1h1v0.5h-1zM-1,-1h1.5v0.5h-1.5zM-2.5,-0.5h5v0.5h-5zM-1.5,0h3.5v0.5h-3.5z',
    },
    {
      paint: 'bush',
      d: 'M-1,-3h2v0.5h-2zM1,-2.5h0.5v0.5h-0.5zM-2.5,-2h1v0.5h-1zM-0.5,-2h2.5v0.5h-2.5zM-2,-1.5h2.5v0.5h-2.5zM-1.5,-1h0.5v0.5h-0.5z',
    },
    { paint: 'leafLight', d: 'M-1,-2.5h2v0.5h-2zM-1.5,-2h1v0.5h-1z' },
    {
      paint: 'flower',
      d: 'M1,-4h0.5v0.5h-0.5zM0.5,-3.5h1.5v0.5h-1.5zM-2.5,-3h1v0.5h-1zM1,-3h1v0.5h-1zM-2.5,-2.5h1.5v0.5h-1.5zM0.5,-1.5h1v1h-1z',
    },
  ],
  pixels: 72,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
